const Types = {
	SET_CHANGE_PASSWORD_LOADING: 'SET_CHANGE_PASSWORD_LOADING',
	SET_CHANGE_PASSWORD_SUCCESS: 'SET_CHANGE_PASSWORD_SUCCESS',
	SET_CHANGE_PASSWORD_ERROR: 'SET_CHANGE_PASSWORD_ERROR',
	CLEAR_STATE_USER: 'CLEAR_STATE_USER',
	EXPIRATION_PLAN_NOTIFICATION: 'EXPIRATION_PLAN_NOTIFICATION'
};

export default Types;
